import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-view-asset-location',
  templateUrl: './modal-view-asset-location.component.html',
  styleUrls: []
})
export class ModalViewAssetLocationComponent implements OnInit {

  latLong: string = '';

  constructor(
    public dialogRef: MatDialogRef<ModalViewAssetLocationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    if (this.data?.latitude && this.data?.longitude) {
      this.latLong = `${this.data.latitude};${this.data.longitude}`;
    }
  }

  ngOnInit(): void {}

  dismiss() {
    this.dialogRef.close(null);
  }
}
